import { FormControl, FormLabel, FormHelperText } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { InputWrapper, LabelStyle } from "../../styles/form";
import { DateRangeValue } from "../columnFilterTypes";

type Props = {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  showLabels?: boolean;
};

const DateRangeFilterField = ({
  value,
  onChange,
  showLabels = true,
}: Props) => {
  const dateError =
    value.from && value.to && value.from > value.to
      ? "From date must be on or before To date"
      : "";

  return (
    <>
      <FormControl sx={{ ...InputWrapper, mb: 1.5, width: "100%" }}>
        {showLabels && (
          <FormLabel sx={LabelStyle}>From</FormLabel>
        )}
        <DatePicker
          format="dd/MM/yyyy"
          maxDate={DateTime.now()}
          value={value.from ? DateTime.fromISO(value.from) : null}
          onChange={(newValue) =>
            onChange({
              ...value,
              from: newValue ? newValue.toFormat("yyyy-MM-dd") : "",
            })
          }
          slotProps={{
            field: {
              clearable: true,
              onClear: () => onChange({ ...value, from: "" }),
            },
          }}
        />
      </FormControl>
      <FormControl sx={{ ...InputWrapper, width: "100%" }} error={!!dateError}>
        {showLabels && <FormLabel sx={LabelStyle}>To</FormLabel>}
        <DatePicker
          format="dd/MM/yyyy"
          maxDate={DateTime.now()}
          value={value.to ? DateTime.fromISO(value.to) : null}
          onChange={(newValue) =>
            onChange({
              ...value,
              to: newValue ? newValue.toFormat("yyyy-MM-dd") : "",
            })
          }
          slotProps={{
            field: {
              clearable: true,
              onClear: () => onChange({ ...value, to: "" }),
            },
          }}
        />
        {dateError && <FormHelperText>{dateError}</FormHelperText>}
      </FormControl>
    </>
  );
};

export default DateRangeFilterField;
